module.exports = __webpack_public_path__ + "static/img/qq-group2.872964f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qq-group2.jpg
// module id = /TtJ
// module chunks = 1